import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thanks-for-email-verification',
  templateUrl: './thanks-for-email-verification.component.html',
  styleUrls: ['./thanks-for-email-verification.component.scss']
})
export class ThanksForEmailVerificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
